import { useSyncExternalStore } from 'react';

interface ReadonlySDKSignal<T> {
    listen(listener: (data: T) => void): () => void;
    value: T;
}

// Bridges @kinopoisk-int/listeners ReadonlySignal / Signal to React via useSyncExternalStore.
export function useSDKSignal<T>(signal: ReadonlySDKSignal<T>): T {
    return useSyncExternalStore(signal.listen, () => signal.value);
}
